import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: theme.spacing(18.75),

    [theme.breakpoints.down('x-xs')]: {
      flexDirection: 'column',
      minWidth: 'auto',
    },
  },

  score: {
    fontWeight: 400,
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    fontFamily: '"Noto Sans"',
    fontSize: theme.spacing(2),
    lineHeight: '-2.4px',
    letterSpacing: theme.spacing(0.25),
    textAlign: 'center',
  },

  divider: {
    fontWeight: 400,
    fontFamily: '"Noto Sans"',
    fontSize: theme.spacing(2),
    letterSpacing: 'normal',
    textAlign: 'center',
  },

  mobileRoot: {
    flexDirection: 'column',
    width: theme.spacing(8),
  },

  mobileContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
}));
